import apiFetch from '../apiFetch'

export default function (saleId, token) {
  return apiFetch({ endPoint: `dossier/sale/${saleId}/header`, method: 'GET', body: null, token: token })
}
